import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Google Analytics Tracking Component
export const GoogleAnalytics = () => {
  const location = useLocation();
  const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

  // Initialize Google Analytics once
  useEffect(() => {
    // Only initialize if GA_MEASUREMENT_ID is provided
    if (!GA_MEASUREMENT_ID || GA_MEASUREMENT_ID === 'YOUR_GA_MEASUREMENT_ID') {
      if (process.env.NODE_ENV === 'development') {
        console.log('📊 Google Analytics: Add your GA_MEASUREMENT_ID to .env to enable tracking');
      }
      return;
    }

    // Load Google Analytics script
    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    script.async = true;
    document.head.appendChild(script);

    // Initialize gtag
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    
    gtag('js', new Date());
    gtag('config', GA_MEASUREMENT_ID, {
      page_path: location.pathname + location.search,
    });

    if (process.env.NODE_ENV === 'development') {
      console.log('✅ Google Analytics initialized:', GA_MEASUREMENT_ID);
    }

    return () => {
      // Cleanup script on unmount
      const scripts = document.querySelectorAll(`script[src*="googletagmanager"]`);
      scripts.forEach(s => s.remove());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [GA_MEASUREMENT_ID]); // location intentionally excluded - tracked separately below

  // Track page views on route change
  useEffect(() => {
    if (window.gtag && GA_MEASUREMENT_ID && GA_MEASUREMENT_ID !== 'YOUR_GA_MEASUREMENT_ID') {
      window.gtag('config', GA_MEASUREMENT_ID, {
        page_path: location.pathname + location.search,
      });
      
      if (process.env.NODE_ENV === 'development') {
        console.log('📊 Page view tracked:', location.pathname);
      }
    }
  }, [location, GA_MEASUREMENT_ID]);

  return null; // This component doesn't render anything
};

// Custom event tracking helper
export const trackEvent = (eventName, eventParams = {}) => {
  if (window.gtag) {
    window.gtag('event', eventName, eventParams);
    
    if (process.env.NODE_ENV === 'development') {
      console.log('📊 Event tracked:', eventName, eventParams);
    }
  }
};

// Common tracking events
export const GA_EVENTS = {
  QUOTE_SUBMITTED: 'quote_form_submitted',
  EMERGENCY_CALL_CLICKED: 'emergency_call_clicked',
  WHATSAPP_CLICKED: 'whatsapp_clicked',
  SERVICE_VIEWED: 'service_viewed',
  GALLERY_OPENED: 'gallery_image_opened',
  RECRUITMENT_EMAIL: 'recruitment_email_clicked',
};
